import React from "react";
import { AlertCircle } from "lucide-react";

const CategoryAlert = ({ showCategoryAlert, setShowCategoryAlert, Segment, selectedCategory, selectedSubcategory }) => {
  if (!showCategoryAlert) return null;

  return (
    <div className="alert-overlay">
      <div className="alert-popup">
        <div className="alert-header">
          <AlertCircle size={24} color="#dc2626" />
          <h3>Category Not Configured</h3>
        </div>
        <div className="alert-content">
          <p>
            The selected combination "{Segment} / {selectedCategory} / {selectedSubcategory}" is not configured in the system.
          </p>
          <p>
            Please contact JMI to configure this combination before proceeding with product registration.
          </p>
        </div>
        <div className="alert-actions">
          <button
            onClick={() => setShowCategoryAlert(false)}
            className="alert-button"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default CategoryAlert;